module.exports = __webpack_public_path__ + "img/F2M5_new.d8053219.jpg";